namespace UError {
  export class Unimplemented extends Error {
    name = "UnimplementedError";
    constructor(message = "Unimplemented") {
      super(message);
    }
  }

  export class Unsupported extends Error {
    name = "UnsupportedError";
    constructor(message = "") {
      super(message);
    }
  }
  export namespace Unsupported {
    export const fn = () => {
      throw new Unsupported();
    };
  }
  export class Unreachable extends Error {
    name = "UnreachableError";

    constructor(message = "Unexpectedly encountered an unreachable case") {
      super(message);
    }
  }
}

export default UError;
